import { observer } from "mobx-react-lite";
import { useResolve } from "@/tsyringe-hooks/useResolve";
import { LoadingScreen } from "@/components/LoadingScreen";
import { PropsWithChildren } from "react";
import { LoadingStore, TOKEN_LoadingStore } from "./LoadingStore";
import { BlockingMessage } from "@/components/BlockingMessage";

export const LoadingView = observer(({ children }: PropsWithChildren) => {
  const store = useResolve<LoadingStore>(TOKEN_LoadingStore);

  if (store.showBlockingLoadingScreen) {
    return <LoadingScreen message={store.message} />;
  }

  if (store.blockingMessageType !== undefined) {
    return <BlockingMessage message={store.blockingMessage} type={store.blockingMessageType} continueAction={store.continueAction} continueMessage={store.continueMessage} />;
  }

  return <>{children}</>;
});
